<template>
    <div class="search">
        <div class="search__section">
            <i class="icon-search"
                @click="onSubmit"
            />
            <form class="form"
                @submit.prevent="onSubmit"
            >
                <input id="search-input-search-query"
                    :ref="searchInputRef"
                    v-model.trim="searchText"
                    class="input"
                    autocomplete="off"
                    :placeholder="placeholder"
                    @input="checkTextDebounce"
                    @keydown.esc="clearText"
                >
            </form>
            <div v-if="isSearchQueryExists"
                id="search-clear-text"
                class="cancel-icon"
                @click="clearText"
            >
                <i class="icon-cancel" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'search',
    props: {
        searchInputRef: {
            default: '',
            type: String,
        },
        placeholderProp: {
            default: null,
            type: String,
        },
        debounceTime: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            searchText: '',
            placeholder: this.placeholderProp || this.$t('rewards.leaderboards.searchPlaceholder'),
        };
    },
    computed: {
        isSearchQueryExists() {
            return this.searchText;
        },
    },
    methods: {
        onSubmit() {
            if (this.searchText === '') {
                return;
            }

            this.$emit('onSubmit', this.searchText);
        },

        checkText() {
            if (this.searchText === '') {
                this.$emit('onClear');

                return;
            }

            this.$emit('onTextChange', this.searchText);
        },

        clearText() {
            this.searchText = '';
            this.$emit('onClear');
        },

        checkTextDebounce() {
            if (this.debounceTime === 0) {
                this.checkText();

                return;
            }

            const clear = () => clearTimeout(this.debounceTimeout);

            if (this.debounceTimeout) {
                clear();
            }

            this.debounceTimeout = setTimeout(() => {
                this.checkText();
                clear();
            }, this.debounceTime);
        },
    },
};
</script>

<style lang="scss" scoped>
.search {
    position: relative;

    &__section {
        display: flex;
        border-radius: 0.8rem;
        padding: 0.5rem 1rem;
        border: 1px solid $hit-gray-color;
        box-sizing: border-box;
        position: absolute;
        z-index: 999;
        top: 0;
        left: 0;
        right: 0;
        align-items: center;

        .icon-search {
            font-size: 1.6rem;
            margin-right: 0.7rem;
        }

        .form {
            width: 100%;

            .input {
                width: 100%;
                height: 100%;
                background: none;
                border: none;

                &::placeholder {
                    opacity: 0.25;
                }
            }
        }

        .cancel-icon {
            display: flex;
            font-size: 1rem;
            border-radius: 50%;
            background: $cyprus-color;
            color: $white-color;
            justify-content: center;
            align-items: center;
            padding: 0.3rem;
        }
    }
}
</style>